"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
exports.toggleMenu = toggleMenu;
var TOGGLE = "maaporssi/menu/TOGGLE";

var initialState = {
  open: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case TOGGLE:
      return {
        open: !state.open
      };
    default:
      return state;
  }
}

function toggleMenu() {
  return {
    type: TOGGLE
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/menu.js
 ** module id = 494
 ** module chunks = 0
 **/